export const STATION_COLORS = ["#2563EB", "#10B981", "#F59E0B", "#8B5CF6", "#EC4899", "#0EA5E9"];

export const stationColor = (stations, id) => {
  const i = stations.findIndex((s) => s.id === id);
  return STATION_COLORS[(i < 0 ? 0 : i) % STATION_COLORS.length];
};

const nf = (d) => new Intl.NumberFormat("it-IT", { minimumFractionDigits: d, maximumFractionDigits: d, useGrouping: "always" });
export const fmtNum = (v, d = 0) => (v === null || v === undefined || Number.isNaN(v) ? "—" : nf(d).format(Number(v)));
export const fmtEur = (v) => (v === null || v === undefined || Number.isNaN(v) ? "—" : new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", useGrouping: "always" }).format(Number(v)));
export const fmtDate = (s) => (s ? new Date(`${s}T00:00:00`).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" }) : "—");

export const todayISO = () => {
  const d = new Date();
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
};
export const monthStartISO = () => `${todayISO().slice(0, 8)}01`;

export const daysAgoISO = (n) => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
};

export const lastMonths = (n) => {
  const now = new Date();
  return Array.from({ length: n }, (_, i) => {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const label = d.toLocaleDateString("it-IT", { month: "long", year: "numeric" });
    return { value: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`, label: label.charAt(0).toUpperCase() + label.slice(1) };
  });
};

export const diffTone = (v) => (v === null || v === undefined ? "text-slate-400" : v >= 0 ? "text-emerald-600" : "text-rose-600");

export const kmlTone = (v) => {
  if (!v) return "bg-slate-100 text-slate-600 border-slate-200";
  if (v >= 3.5) return "bg-emerald-50 text-emerald-700 border-emerald-200";
  if (v >= 2.5) return "bg-amber-50 text-amber-700 border-amber-200";
  return "bg-rose-50 text-rose-700 border-rose-200";
};
